/**
 * Avatar face catalogue API — GET /api/v1/avatars/faces.
 *
 * The provider-neutral face catalogue behind `AvatarFacePicker`, served by the
 * standalone livekit-free faces router (`modules/avatars/api/faces_routes.py`).
 *
 * A thin named adapter over the ORVAL-GENERATED fetcher, same shape as
 * `avatarSessionApi`: it unwraps the legacy `{"data": [...]}` envelope so the
 * picker consumes a plain list. It used to hand-roll the request and its response
 * type because the route's model was inline and the generated op came back
 * `unknown` — that model is now generated from
 * `shared/schemas/avatars/avatar_faces_response.schema.json`, so the type below
 * is the backend's own (WI 123cfe04).
 */
import { listFacesApiV1AvatarsFacesGet } from '../../../generated/api/avatars/avatars';
import type { AvatarFace } from '../types';

export const avatarFacesApi = {
  listFaces: async (): Promise<AvatarFace[]> => {
    const result = await listFacesApiV1AvatarsFacesGet();
    return result.data;
  },
};
